import { useSelector } from 'react-redux';
import { ManagedChannelType } from 'src/graphql';
import { State } from 'src/types';
import { convertDateToISO } from 'src/utils/time';

export const useManagedChannel = (data: ManagedChannelType[]) => {
  const userId = useSelector(
    ({ globalUsers }: State) => globalUsers?.currentUser?.id,
  );

  const hasSentMessage =
    data?.some((entry) => entry.manager === Number(userId)) ?? false;

  const channelEntries = (data ?? []).flatMap((entry) => {
    const entries = [];
    const author = entry.User.displayName || entry.User.name;
    if (entry.enteredChannel) {
      entries.push({
        type: 'notification' as const,
        id: `${entry.id}-enter`,
        author,
        createdAt: convertDateToISO(entry.enteredChannel) ?? '',
        isReporter: false,
        value: `${author} joined the chat`,
      });
    }
    if (entry.exitedChannel) {
      entries.push({
        type: 'notification' as const,
        id: `${entry.id}-exit`,
        author,
        createdAt: convertDateToISO(entry.exitedChannel) ?? '',
        isReporter: false,
        value: `${author} left the chat`,
      });
    }
    return entries;
  });

  return {
    channelEntries,
    hasSentMessage,
  };
};
